module.exports = __webpack_public_path__ + "img/icon-settings.48ba3376.svg";